module.exports = __webpack_public_path__ + "img/email-sent.d1ebf9b1.svg";